enum MobileModeChangeSource {
  User = 'user',
  Browser = 'browser',
}
export default MobileModeChangeSource;
